var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"help_title"},[_c('p',[_vm._v(_vm._s(_vm.agreement.name))]),_c('p')]),_c('van-divider',{style:({ borderColor: '#eee', margin: '0' })}),_c('div',{staticClass:"help",domProps:{"innerHTML":_vm._s(_vm.agreement.value)}})],1),_c('v-foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }